// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-D1":"D1_outdoor-recreation-D1__Dzd4L"};